<template>
  <v-dialog persistent v-model="show" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>

      <h2>{{ $t('login.password.forgot-password') }}</h2>
      <v-card-text class="pl-0 pr-0">
        {{ $t('login.password.sms-info') }}
      </v-card-text>
      <MessageBox v-if="requestFail" class="mt-2 mb-8" type="alert">
        <p>{{ $t('login.password.phone-missing') }}</p>
        <p v-html="$t('login.password.phone-missing-contact')"></p>
      </MessageBox>
      <div>
        <v-form ref="form">
          <v-text-field
            outlined
            :label="$t('fields.mobilephone')"
            v-model="mobilephone"
            :rules="[rules.required, rules.phone]"
            :error-messages="error"
            @input="clearErrorMessages"
          />
          <ActionButton :isDisabled="requestPending" class="mt-4" actionIcon="$sl-mobile" @click="requestSMScode">{{
            $t('login.password.send-code-button')
          }}</ActionButton>
        </v-form>
        <ActionButton class="mt-4" actionIcon="$sl-cancel" type="application" @click="$emit('close')">{{
          $t('labels.cancel')
        }}</ActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'
import MessageBox from '@/components/Common/MessageBox.vue'

export default {
  name: 'ForgotPasswordModal',

  mixins: [RulesMixin],

  props: {
    show: false
  },

  data: () => ({
    mobilephone: '',
    error: '',
    requestFail: false,
    requestPending: false
  }),

  components: {
    ActionButton,
    MessageBox
  },

  methods: {
    requestSMScode() {
      this.requestFail = false
      const valid = this.$refs.form.validate()
      if (!valid) return
      this.requestPending = true
      API.requestSMScode({mobilephone: this.mobilephone})
        .then(({data}) => {
          if (data.success) {
            this.$emit('close', {mobilephone: this.mobilephone, sentTime: new Date()})
            return
          }
          this.requestFail = true
        })
        .catch(() => {
          this.error = this.$t('login.password.error-on-sms-send')
        })
        .finally(() => {
          this.requestPending = false
        })
    },
    clearErrorMessages() {
      this.error = ''
    }
  }
}
</script>

